// extracted by mini-css-extract-plugin
export var buttons = "styles-module--buttons--H7qmh";
export var container = "styles-module--container--XzYeu";
export var input = "styles-module--input--wtANP";
export var schemaLabel = "styles-module--schemaLabel--M8AKJ";